import React from 'react';
import { groupBy } from 'ramda';
import { Paragraph } from '@trainline/depot-web';
import { css } from 'aphrodite/no-important';
import dayjs from 'dayjs';
import { FormattedMessage } from 'react-intl';

import { PaygJourney } from '@contactcentre-web/hooks/api/useFetchJourneys';

import { Journey } from '../Journey/Journey';
import messages from '../../messages';

import styles from './styles';

interface Props {
  journeys?: PaygJourney[];
  isPending?: boolean;
}

export const JourneyList = ({ journeys, isPending = false }: Props) => {
  if (!journeys || journeys.length === 0) {
    return (
      <Paragraph>
        <FormattedMessage
          {...(isPending ? messages.noPendingJourneys : messages.noValidatedJourneys)}
        />
      </Paragraph>
    );
  }

  const journeyGroup = isPending
    ? groupBy((journey) => journey.trackingId, journeys)
    : groupBy((journey) => journey.railDay, journeys);

  const journeyKeys = Object.keys(journeyGroup);

  return (
    <>
      {journeyKeys.map((key) => {
        const journeyByKey = journeyGroup[key];
        return (
          <div key={key} className={css(styles.groupWrapper, isPending && styles.pendingGroup)}>
            <Paragraph color="subtle" typeStyle="body" className={css(styles.date)}>
              {/* set undefined for isPending to mock current day */}
              {dayjs(isPending ? undefined : journeyByKey[0].railDay).format('D MMMM')}
            </Paragraph>
            <div className={css(styles.journeyWrapper)}>
              {journeyByKey.map((journey) => (
                <Journey key={journey.trackingId} journey={journey} />
              ))}
            </div>
          </div>
        );
      })}
    </>
  );
};
